export const selectOutstandingPayments = state => state.outstandingPayments.data;
export const selectOutstandingPaymentsLoading = state => state.outstandingPayments.isLoading;
